module.exports = __webpack_public_path__ + "static/media/ecofuturo-logo-03.b4253858.png";